export { default } from './SectionPurpose';